import { WebsocketWrapper } from '@missionlabs/smartagent-lib-shared';
import { IWebSocketParameters } from '@missionlabs/smartagent-lib-shared';

import { WebSocketCompanionTargets, WebSocketCompanionRoutes } from 'store/websocketCompanion/websocketCompanion.types';

export default class WSCompanionClient extends WebsocketWrapper {
        constructor(config: IWebSocketParameters) {
        super(config);
    }

    sendMessage(action: string, data: Record<string, any> = {}) {
        return this.send(WebSocketCompanionRoutes.COMPANION_SEND_MESSAGE, {
            data: {
                action,
                data,
            },
            target: WebSocketCompanionTargets.COMPANION,
        });
    }
}